import React from "react";
import { Slider, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import moment from "moment/moment";

import CustomAvatar from "../../CustomAvatar";
import { getPlayerState } from "../../../../redux/features/playerSlice";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import CustomCard from "../../CustomCard";
import CustomCircleButton from "./../../CustomCircleButton/index";

const TopicList = ({ rowData, type, firstIndex, lastIndex }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { url, playing } = useSelector(getPlayerState);
  const theme = useTheme();

  return (
    <Box key={rowData.pk} sx={{ display: "flex" }}>
      {type === "discussion" && (
        <Box sx={{ ml: "2px", mr: "8px", mt: "auto", mb: "15px" }}>
          {lastIndex ? (
            <CustomAvatar
              link={`/profile/${rowData.author.username}`}
              size={"45px"}
              src={rowData.author.avatar}
            />
          ) : (
            <Box sx={{ width: "45px" }} />
          )}
        </Box>
      )}

      <CustomCard
        pSize={16}
        shadowSize={4}
        radius={16}
        maxHeight={type === "discussion" ? 171 : 150}
        mBottom={16}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {type === "discussion" && firstIndex && (
            <>
              <Typography
                onClick={() => navigate(`/profile/${rowData.author.username}`)}
                sx={{
                  fontSize: "15px",
                  // fontWeight: 600,
                  color: "secondary.main",
                  lineHeight: "16px",
                  cursor: "pointer",
                  pl: "2px",
                  mb: "3px",
                }}
              >
                {rowData.author.nickname}
              </Typography>
              {/* <Box sx={{ mb: "6px" }}>
               <Replayed color='black' />
                  </Box> */}
            </>
          )}

          <Box
            onClick={() =>
              navigate(
                `/${
                  type === "opinion"
                    ? `table/${params.tableId}/opinions/${params.opinionId}`
                    : `table/${params.tableId}/discussions/${params.discussionId}`
                }/topics/${rowData.pk}`
              )
            }
            sx={{
              display: "flex",
              pb: "16px",
              borderBottom: "2px solid",
              borderColor: "black.main",
              cursor: "pointer",
            }}
          >
            {" "}
            <CustomAvatar
              src={
                rowData.thumbnail ? rowData.thumbnail : rowData.author.avatar
              }
              size={64}
              iconType={
                (url === rowData.file && playing) ||
                (url === rowData.extra && playing)
                  ? "pause"
                  : rowData.content_type
              }
              iconSize={32}
              round={"8px"}
              alt={rowData.author.nickname}
              video
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                ml: "8px",
                // height: 64,
                overflow: "hidden",
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Tahrir",
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "24px",
                  width: "95%",
                  direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {rowData.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "100px",
                  }}
                >
                  <Slider
                    aria-label='timeline'
                    min={0}
                    max={1}
                    step={0.001}
                    value={rowData.time_watched / rowData.duration}
                    sx={{
                      position: "absolute",
                      padding: "0 !IMPORTANT",
                      width: "100px",
                      color: "primary.main",
                      cursor: "default",
                      "& .MuiSlider-track": {
                        border: "none",
                      },
                      "& .MuiSlider-thumb": {
                        display: "none",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "blackDisabled.main",
                        opacity: 0.5,
                      },
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      lineHeight: "14px",
                      color: "mute.main",
                      textTransform: "uppercase",
                    }}
                  >
                    {/* {type === "opinion" &&
                      moment(rowData.created_at).format("DD/MM/YYYY") + " - "} */}

                    {moment(rowData.created_at).format("h:mm a")}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            onClick={() =>
              navigate(
                `/table/${params.tableId}/${
                  type === "opinion"
                    ? `opinions/${params.opinionId}`
                    : `discussions/${params.discussionId}`
                }/topics/${rowData?.pk}/comment`
              )
            }
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "8px",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: "secondary.main",
                lineHeight: "16px",
                cursor: "pointer",
                mt: "4px",
              }}
            >
              {rowData.comments_count === 0 && "Add a comment"}
              {rowData.comments_count === 1 &&
                rowData.comments_count + " Comment"}
              {rowData.comments_count > 1 &&
                rowData.comments_count + " Comments"}
            </Typography>
            <Box sx={{ width: "24px", height: "24px" }}>
              <CustomCircleButton
                width='25px'
                height='25px'
                bgColor='white.main'
                color='black.main'
                bShadow='none'
                hoverBgColor='white.main'
                hoverColor='black.main'
                hoverBorder={`1.5px solid ${theme.palette.black.main}`}
                activeBgColor='black.main'
                activeColor='white.main'
              >
                <ArrowForwardIosRoundedIcon sx={{ fontSize: "14px" }} />
              </CustomCircleButton>
            </Box>
          </Box>
        </Box>
      </CustomCard>
    </Box>
  );
};

export default TopicList;
